<template>
  <StepContainer
    v-loading="isLoading"
    :title="$t('APPS.DRAFT.STEPS.UPLOAD_FILES')"
  >
    <NewAppBundleFlow v-if="isBundleRelease" :bundle="draftApp.bundleRelease" />

    <AppFilesUploader v-else />

    <NewAppPackagesTable
      v-if="draftApp.packages.length"
      :packages="draftApp.packages"
      :is-bundle-release="isBundleRelease"
    />

    <StepControllers slot="actions" @change-step="goToStep" />
  </StepContainer>
</template>

<script>
import StepContainer from '../common/StepContainer';
import AppFilesUploader from './AppFilesUploader';
import NewAppPackagesTable from '../common/NewAppPackagesTable';
import NewAppBundleFlow from './NewAppBundleFlow';
import { mapActions, mapGetters } from 'vuex';
import { DRAFT_APP, CHANGE_DRAFT_APP_STATE } from '@/store/types';
import StepControllers from '../common/StepControllers';

export default {
  name: 'AppFilesStep',

  components: {
    StepContainer,
    AppFilesUploader,
    NewAppPackagesTable,
    NewAppBundleFlow,
    StepControllers,
  },

  inject: ['stepperController'],

  data() {
    return {
      isLoading: false,
      errors: [],
    };
  },

  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
    isBundleRelease() {
      return Boolean(this.draftApp.bundleRelease?.state);
    },
  },

  created() {
    this.stepperController.onStepClick(this.goToStep);
  },

  beforeDestroy() {
    this.stepperController.removeOnStepClick(this.goToStep);
  },

  methods: {
    ...mapActions({ checkAndChangeStep: CHANGE_DRAFT_APP_STATE }),

    goToStep(step) {
      this.isLoading = true;

      this.checkAndChangeStep({ to: step })
        .catch(({ message, errors = [] }) => {
          this.$message.error(message);
          this.errors = errors;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
